import script from "./ImageHighlighter.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageHighlighter.vue?vue&type=script&setup=true&lang=js"

import "./ImageHighlighter.vue?vue&type=style&index=0&id=1396adca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1396adca"]])

export default __exports__